import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DeviceEnum, PatientBase, ReferenceTypeEnum } from '../../core';
import { IPlanControl } from '../../models';
import { PlanFormService } from '../../services';
import { AnatomicalSiteLabelPipe, BaseComponent, DeviceLabelPipe, PlanTypeLabelPipe } from '../../shared';


/**
 * Plan overview section component.
 */
@Component({
	selector: 'plan-overview',
	templateUrl: './plan-overview.component.html',
	imports: [
		DeviceLabelPipe,
		PlanTypeLabelPipe,
		AnatomicalSiteLabelPipe
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PlanOverviewComponent extends BaseComponent implements OnInit {

	readonly planFormSrv = inject(PlanFormService);

	form?: FormGroup<IPlanControl>;
	patient: PatientBase | null = null;

	readonly deviceEnum = DeviceEnum;
	readonly referenceEnum = ReferenceTypeEnum;


	ngOnInit(): void {
		this.planFormSrv.getForm().subscribe(form => {
			this.form = form;
			this.patient = this.planFormSrv.patient;
		});
	}

}
